<iframe id="iframe1" *ngIf="src && version === 'ASPX'" class="frameview" [src]="src" frameborder="0" (load)="onLoad()"></iframe>

  <ng-container *ngIf="version !== 'ASPX'">
    <q-action-co-card *ngIf="idActionCo && idActionCo !== '0'" [idActionCo]="idActionCo"
                      [IdDonnee]="IdDonnee"
                      [Date]="Date"></q-action-co-card>

    <q-action-co-card *ngIf="(!idActionCo || idActionCo === '0') && mode" [TypeDevis]="mode"
                      [IdDonnee]="IdDonnee"
                      [Date]="Date"></q-action-co-card>

    <ng-container *ngIf="(!idActionCo || idActionCo === '0') && !mode">
      <div class="container">
        <div class="row justify-content-center align-items-center my-5 q-text-xl q-bold">
          <p>Choix du mode d'action commerciale</p>
        </div>
        <ng-container *ngFor="let strMode of lstModes">
          <div class="row justify-content-center align-items-center my-3">
            <button class="q-btn q-main col-12 col-md-6 col-lg-4 col-xl-3 q-pointer" (click)="mode = strMode.id">{{strMode.value}}</button>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </ng-container>


